import { useQuery } from '@tanstack/react-query';
import { listJobs } from '../api';
import type { JobQuery } from '@maker-toolchest/shared';

export function useJobs(query: JobQuery = {}) {
  return useQuery({
    queryKey: ['jobs', query],
    queryFn: () => listJobs(query),
  });
}
